import { render } from "./KSFromTemplate.vue?vue&type=template&id=24a755a5"
import script from "./KSFromTemplate.vue?vue&type=script&lang=js"
export * from "./KSFromTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__